Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function () {
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
});



$(document).ready(function () {
    
    initDropdownMenu();
    initContentBlockYouTubeChannel();
    //initContentBlockBooking();

    $('.navbar-controls .search').on('click', function(e) {
        e.preventDefault();

        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            $('#search-bar').addClass('open');
        } else {
            $('#search-bar').removeClass('open');
        }
    });

    $('.navbar-main .navbar-collapse').on('show.bs.collapse', function() {
        if ($(this).parents('.is-child-nav').length > 0) {
            return;
        }

        var $searchbar = $('#search-bar').detach();
        $searchbar.addClass('open');
        $(this).append($searchbar);

        var $lang = $('.languages.dropdown').detach();
        $lang.insertBefore('#main-nav .navbar-nav');
    });

    $('.navbar-main .navbar-collapse').on('hidden.bs.collapse', function () {
        if ($(this).parents('.is-child-nav').length > 0) {
            return;
        }

        var $searchbar = $('#search-bar').detach();
        $searchbar.removeClass('open');
        $searchbar.insertAfter('.navbar-main');

        var $lang = $('.languages.dropdown').detach();
        $lang.insertAfter('.navbar-controls .search');
    });

    
    $('article.collapsed-preview .collapsed-preview-footer a').on('click', function (e) {
        e.preventDefault();

        $(this).parents('article').removeClass('collapsed-preview');
        $(this).parent().remove();
    });

	$(document).on('click', '[data-toggle="lightbox"]', function(event) {
		event.preventDefault();
		var currentTarget = null;
		$(this).ekkoLightbox({
			showArrows: true,
			onNavigate: function(direction, itemIndex){
				updateAddThis();
			},
			onShown : function(){
				//updateAddThis();
			},
			onHide: function(){
                $('#at-image-sharing-tool, #at-image-sharing-mobile-icons').addClass('fadeOut').addClass('at4-hide');
			},
			onContentLoaded : function(){
				updateAddThis();
			}
		});
	});

    $('.media-block.parallax').each(function(key, item) {
        new Parallax(item);
    });

    if ($('.sb-collection, .sb-player').length > 0) {
        window.sbAsyncInit = function () {
            SB.init({
                fqdn: "klappen.streamingbolaget.se"
            });
        };

        (function () {
            var sb = document.createElement('script'); sb.type = 'text/javascript'; sb.async = true; sb.src = '//klappen.streamingbolaget.se/apps/sdk/SB.min.js';
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sb, s);
        })();
    }

    $(document).on('click', '.close-cookie', function (e) {
        e.preventDefault();
        $(this).parents('.cookie-bar').remove();

        setTimeout(function () {
            var days = 30;
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

            var expires = date.toGMTString();
            document.cookie = 'accepted_cookies=true; expires=' + expires + '; path=/';
        }, 260);
    });

    // Fix for IE that won't play html5 video, remove the element to show the poster
    if ($('.video-banner video').length > 0 && window.navigator.userAgent.match(/(MSIE|Trident)/)) {
        $('.video-banner video').detach();
    }

    // Fix for iOS-devices that sometimes won't autoplay without interaction
    // like when in "low power mode".
    $('body').on('click touchstart', function () {
        var $videos = $('.video-banner video');
        if ($videos.length === 0)
            return;

        $videos.each(function() {
            if (!this.playing) {
                this.play();
            }
        });
    });

});

var initDropdownMenu = function () {
    var $elements = $('.dropdown-menu [data-toggle=dropdown]');
    if ($elements.length === 0)
        return;

    $($elements).on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().siblings().removeClass('show');
        $(this).parent().toggleClass('show');
    });
};

//function onYouTubeIframeAPIReady() {
//	if($('.media-block .media.video').length){
//		var player = new YoutubeEmbed($('.media-block .media.video'));	
//	}
//};

function onYouTubeIframeAPIReady() {
    jQuery("body").addClass('yesp-youtube-iframe-ready');
}

var initContentBlockYouTubeChannel = function () {
    var $elements = $('.vix-player');
    if ($elements.length === 0)
        return;
    
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    $elements.each(function () {

        var $this = $(this);

        $this.youtube_video({
            api_key: $this.attr('data-apikey'),
            playlist: $this.attr('data-playlist').length > 0 ? $this.attr('data-playlist') : false,
            channel: $this.attr('data-channel').length > 0 ? $this.attr('data-channel') : false,
            user: $this.attr('data-user').length > 0 ? $this.attr('data-user') : false,
            videos: $this.attr('data-videos').length > 0 ? $this.attr('data-videos').split(",") : false,
            playlist_type: 'horizontal',
            now_playing_text: 'Spelas',
            load_more_text: 'Ladda fler',
            force_hd: true,
            hide_youtube_logo: true,
            fwd_bck_control: false,
            show_channel_in_title: false,
            first_video: 0,
            autoplay: $this.attr('data-autoplay') === 'true',
            continuous: $this.attr('data-continuous') === 'true',
            show_playlist: $this.attr('data-hideplaylist') === 'false',
            colors: {
                controls_bg: 'rgba(5,190,250,.85)',
                buttons: 'rgba(255,255,255,.5)',
                buttons_hover: 'rgba(255,255,255,1)',
                buttons_active: 'rgba(255,255,255,1)',
                time_text: '#FFFFFF',
                bar_bg: 'rgba(255,255,255,.5)',
                buffer: 'rgba(255,255,255,.25)',
                fill: '#FFFFFF',
                video_title: '#FFFFFF',
                video_channel: '#92a5b0',
                playlist_overlay: 'rgba(5,190,250,.85)',
                playlist_title: '#FFFFFF',
                playlist_channel: '#FFFFFF',
                scrollbar: '#FFFFFF',
                scrollbar_bg: 'rgba(255,255,255,.25)'
            }
        });
    });
};

//var initContentBlockBooking = function () {
//    var $elements = $('.booking select.dates');
//    if ($elements.length === 0)
//        return;

//    $elements.first().show();

//    $('.booking select.periods').on('change', function (e) {
//        var id = $(this).val();
//        var $parent = $(this).parents('.booking');
//        $('select.dates', $parent).hide();
//        $('select.dates.' + id, $parent).show();
//    });

//    $('.booking a.btn').on('click', function (e) {
//        e.preventDefault();

//        var $parent = $(this).parents('.booking');
//        var dates = $('select.dates:visible', $parent).val();
//        if (dates === 'X')
//            return;

//        var destination = $('select.destinations', $parent).val();
//        var url = $(this).attr('href');

//        var query = [];
//        if (dates.length > 0)
//            query.push(dates);

//        if (destination.length > 0)
//            query.push('resmal=' + destination);

//        if (query.length > 0) {
//            url += '&' + query.join('&');
//        }

//        window.location = url;
//    });
//};